/**
*
*/
import React, { Fragment, useState, useEffect } from 'react';
import Modal from 'react-modal';

//Apis
import { authSignIn } from '../tm-apis';

//Helpers
import { setDefaultEnvObj, gtmSend } from '@tickled-media/web-components.tm-helpers';

//Icons
import TapIcon from "./icons/TapIcon";
import EmailIcon from "./icons/EmailIcon";
import GoogleIcon from "./icons/GoogleIcon";
import FacebookIcon from "./icons/FacebookIcon";
import CrossRegularSmdBlackIcon from "./icons/CrossRegularSmdBlackIcon";

//Other Components
// import AlertNotification from 'Components/common/AlertNotification';
import FacebookLogin from './react-facebook-login';
import EmailLoginOTPWidget from '../tm-email-login-otp-widget';
import ThreeBounceAnimationIcon from "@tickled-media/web-components.tm-three-bounce-loader";
import Notification from "@tickled-media/web-components.tm-notification";

//Style files
import cx from 'classnames/bind';
import GoogleOAuthLogin from "./components/GoogleOAuth/index.js";
// import './style.css'

const customStyles = {
    content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)',
        width                 : '820px',
        borderRadius          : '12px'
    }
};

const notificationConfig = {device: "desktop", type: "error", title: "Validation Error", duration: 6, placement: "topRight"};

const FacebookLoginButton = (props) => {
	const {
		handleLoading,
        SiteConfig = {},
        translation,
        communityUserLoginFn,
        emailWidgetShowAsModal,
	} = props;

	const onFacebookResponse = (response) => {
        const { accessToken, code } = response;

        communityUserLoginFn({
	    	method: 'facebook',
            token: accessToken,
	    })
    }

    const onClickHandler = () => {
        gtmSend(`loginSignup`, `Login and Signup`, `Log in with Facebook`, `--`, 0 , {"action_detail" : "Log in with Facebook"});
        handleLoading(true);
    }

    return (
	    <FacebookLogin
	        appId={SiteConfig['fbAppId']}
	        autoLoad={false}
	        scope="email"
	        fields="name,email"
            onSuccess={(res) => onFacebookResponse(res)}
	        onFail={(e) => {handleLoading(false); console.warn('FacebookLogin', e)}}
	        render={({onClick}) =>
            <div onClick={() => {  onClickHandler(); onClick() }}
              className={cx(`text-wrap ${emailWidgetShowAsModal? 'align-start' : ''}`)}
            >
              <div className={cx(`icon-wrap`)}>
                <FacebookIcon />
              </div>
              <div className={cx(`text`)}>
                {translation[`facebookBtnText`]}
              </div>
            </div>
          }
          // useRedirect={isSafari()}
	        // redirectUri={''}
	        // isMobile={false}
	        // disableMobileRedirect={true}
            // isDisabled={props.tncAcceptance? false : true}
	   	/>
	)
}

const GoogleLoginButton = (props) => {
	const {
		handleLoading,
    SiteConfig = {},
    translation,
    communityUserLoginFn,
    emailWidgetShowAsModal,
	} = props;

	const onGoogleResponse = (response = {}) => {
        const { code } = response;
        if (communityUserLoginFn) {
            communityUserLoginFn({
                method: 'google',
                code,
            });
        }
    }

    const googleRedirectUri = `${SiteConfig['siteUrl']}${SiteConfig['googleOAuthRedirectPath'] || '_google-oauth'}`;

    return (
        <GoogleOAuthLogin
            clientId={SiteConfig['googleClientId']}
            redirectUri={googleRedirectUri}
            onAuthStart={() => {
                gtmSend(`loginSignup`, `Login and Signup`, `Log in with Google`, `--`, 0 , {"action_detail" : "Log in with Google"});
                handleLoading(true);
            }}
            onAuthCancel={() => {
                handleLoading(false);
            }}
            onSuccess={(resp) => {
                onGoogleResponse(resp);
                // handleLoading(false);
            }}
            onError={() => {
                handleLoading(false);
            }}
        >
            <div className={cx(`text-wrap ${emailWidgetShowAsModal ? 'align-start' : ''}`)}>
                <div className={cx(`icon-wrap`)}>
                    <GoogleIcon/>
                </div>
                <div className={cx(`text`)}>
                    {translation[`googleBtnText`]}
                </div>
            </div>
        </GoogleOAuthLogin>
	)
}


const CommunityLoginWidget = (props) => {
    const {
        user,
        onCommunityLoginWidgetClose,
        emailWidgetShowAsModal = false,
        SiteConfig = {},
        translation,
        onSuccess,
        showMobileLogin = false,
        enabledCountries,
        isShowGoogleLoginButton = true,
        isShowFacebookLoginButton = true,
    } = props;

    const [tncAcceptance, setTncAcceptance] = useState(true),
    [showEmailWidget, setShowEmailWidget] = useState(false),
    [type, setType] = useState('mobile'),
    [showTabSwitcher, setShowTabSwitcher] = useState(false),
    [isLoading, setLoading] = useState(false);

    useEffect(()=>{
        if(user.country && enabledCountries && enabledCountries.length && enabledCountries.indexOf(user.country) !== -1 && showMobileLogin){
            setShowTabSwitcher(true)
        }else{
            setType('email');
        }
    },[])

    const handleLoginType = (loginType) => {
        setType(loginType)
    }


	const handleLoading = (flag) => {
        setLoading(flag);
	}

    const onEmailTemplateClose = (flag) => {
        setShowEmailWidget(flag);
    }

    const communityUserLoginFn = (params = {}) => {
        const { method, code, token, inviteCode } = params;

        const payload = {
            method: params.method,
        }
        if (code) {
            payload['code'] = code;
        } else if (token) {
            payload['token'] = token;
        } else {
            console.error('unexpected error. did not receive code/token')
            Notification.send({
                ...notificationConfig,
                title: translation[`notification`],
                message: translation['somethingWentWrong']
            });
        }

        if (inviteCode) {
            payload['inviteCode'] = inviteCode;
        }

        authSignIn(setDefaultEnvObj(user), user, payload).then((data) => {
            if (data && data.response && data.status === true) {
                if (data.response['is_user_created']) {
                    gtmSend(`loginSignup_signup_successful`, `Login and Signup`, `Sign Up Successful via ${method === `google` ? 'Google' : 'Facebook'}`, `--`, 0 , {"action_detail" : `Sign Up Successful via ${method === `google` ? 'Google' : 'Facebook'}`});
                } else {
                    gtmSend(`loginSignup_login_successful`, `Login and Signup`, `Login Successful via ${method === 'google' ? 'Google' : 'Facebook'}`, `--`, 0 , {"action_detail" : `Login Successful via ${method === 'google' ? 'Google' : 'Facebook'}`})
                }

                if (onSuccess) {
                    onSuccess(data.response);
                }
            } else {
                // handle user login failed.
                setLoading(false);
                gtmSend(`loginSignup`, `Login and Signup`, `Login Error via ${method}`, `${translation['somethingWentWrong']}`, 0 , {"action_detail" : `Login Error via ${method}`})
                Notification.send({
                    ...notificationConfig,
                    title: translation[`notification`],
                    message: translation['somethingWentWrong']
                });
            }
        }).catch((err) => {
            console.warn("Auth error", err);
            setLoading(false);
            if (err.response && err.response.data) {
                const data = err.response?.data || {};
                gtmSend(`loginSignup`, `Login and Signup`, `Login Error via ${method}`, data.error?.code ? data.error.code : translation['somethingWentWrong'], 0 , {"action_detail" : `Login Error via ${method}`})
                Notification.send({
                    ...notificationConfig,
                    title: translation[`notification`],
                    message: data?.message ? data.message : translation['somethingWentWrong']
                });
            }
        });
    }

    const onTncAcceptanceChange = (isChecked) => {
        setTncAcceptance(isChecked)
        if(isChecked) {
            gtmSend(`loginSignup_checkTnC`, `Login and Signup`, `--`, `--`, 0)
        } else {
            Notification.send({
                ...notificationConfig,
                type: "info",
                title: translation[`notification`],
                message: translation[`alertAcceptanceMessage`] || ''
            });
            gtmSend(`loginSignup_uncheckTnC`, `Login and Signup`, `--`, `--`, 0)
            gtmSend(`loginSignup_error_TnC`, `Login and Signup`, `--`, `--`, 0)
        }
    }

    const onLoginSuccess = (data) => {
        if(onSuccess) {
            onSuccess(data)
        }
    }

    return (

        <div className={cx('loginModal-view')}>
             { isLoading && <ThreeBounceAnimationIcon /> }
             {
                !emailWidgetShowAsModal &&
                <div className={cx(`close-icon`)} onClick={() => { if (onCommunityLoginWidgetClose) onCommunityLoginWidgetClose(false) }}>
                    <CrossRegularSmdBlackIcon />
                </div>
            }
            {/* {
                !tncAcceptance &&
                <AlertNotification notificationType={`error`} message={translation[`alertAcceptanceMessage`]}/>
            } */}

            {
                !emailWidgetShowAsModal &&
                <div className={cx(`tap-icon`)}>
                    <TapIcon />
                </div>
            }

            <div className={`heading`}>
                <h1 className={`${emailWidgetShowAsModal? 'loginPageTxt' : ''}`}>
                    {translation[`loginHeading`]}
                </h1>
            </div>

            <div className={cx(`button-wrapper`)}>
                <div className={cx(`email-btn ${tncAcceptance ? '' : 'disabled-btn'}`)}>
                    <div className={cx(`text-wrap ${emailWidgetShowAsModal? 'align-start' : ''}`)} onClick={() => {gtmSend(`loginSignup`, `Login and Signup`, `Log in with Email or Mobile`, `--`, 0 , {"action_detail" : "Log in with Email or Mobile"}); tncAcceptance && setShowEmailWidget(true)}}>
                        <div className={cx(`icon-wrap`)}>
                            <EmailIcon />
                        </div>
                        <div className={cx(`text`)}>
                            {type === 'mobile' ? translation[`emailMobileBtnText`] : translation[`emailBtnText`]}
                        </div>
                    </div>
                </div>

                {
                    isShowGoogleLoginButton &&
                    <div className={`gogole-btn ${tncAcceptance ? '' : 'disabled-btn'}`}>
                        <GoogleLoginButton
                            user={user}
                            handleLoading={handleLoading}
                            SiteConfig={SiteConfig}
                            translation={translation}
                            communityUserLoginFn={communityUserLoginFn}
                            tncAcceptance={tncAcceptance}
                            emailWidgetShowAsModal={emailWidgetShowAsModal}
                        />
                    </div>
                }

                {
                    isShowFacebookLoginButton &&
                    <div className={`facebook-btn ${tncAcceptance ? '' : 'disabled-btn'}`}>
                        <div className={cx(`text-wrap fb-wrap`)}>
                            <FacebookLoginButton
                                user={user}
                                handleLoading={handleLoading}
                                SiteConfig={SiteConfig}
                                translation={translation}
                                communityUserLoginFn={communityUserLoginFn}
                                tncAcceptance={tncAcceptance}
                                emailWidgetShowAsModal={emailWidgetShowAsModal}
                            />
                        </div>
                    </div>
                }
            </div>

            <div className={cx('acceptance-wrapper')}>
                <div className={cx(`acceptance-wrap`)}>
                    <input
                        id="accept-input"
                        checked={tncAcceptance}
                        onChange={e => {onTncAcceptanceChange(e.target.checked)}}
                        type="checkbox"
                    />
                    <div className={cx('text-wrap')}>
                        {translation['tncAcceptance']}
                        <a href='/privacy' target="_blank" onClick={() => {gtmSend(`loginSignup_viewTnC`, `Login and Signup`, `--`, `--`, 0)}}>
                            {translation['tnc']}
                        </a>
                        {translation['and']}
                        <a href='/community-guideline' onClick={()=>gtmSend(`loginSignup_viewCommunityGuidelines`, `Login and Signup`, `--`, `--`, 0)} target="_blank">
                            {translation['guidelines']}
                        </a>
                    </div>
                </div>
            </div>

            {
                !emailWidgetShowAsModal &&
                <div className={cx(`footer`)}>
                    <div className={cx(`text`)}>The Numer #1 Parenting Site</div>

                    <div className={cx("footer-country-flag")}>
                        <div className={cx("flag-icons")}>
                            <div>
                                <em className={cx("flag-icons-sprite flag-singapore")}></em>
                                <p>Singapore</p>
                            </div>
                        </div>
                        <div className={cx("flag-icons")}>
                            <div>
                                <em className={cx("flag-icons-sprite flag-thailand")}></em>
                                <p>Thailand</p>
                            </div>
                        </div>
                        <div className={cx("flag-icons")}>
                            <div>
                                <em className={cx("flag-icons-sprite flag-indonesia")}></em>
                                <p>Indonesia</p>
                            </div>
                        </div>
                        <div className={cx("flag-icons")}>
                            <div>
                                <em className={cx("flag-icons-sprite flag-philippines")}></em>
                                <p>Philippines</p>
                            </div>
                        </div>
                        <div className={cx("flag-icons")}>
                            <div>
                                <em className={cx("flag-icons-sprite flag-malaysia")}></em>
                                <p>Malaysia</p>
                            </div>
                        </div>
                        <div className={cx("flag-icons")}>
                            <div>
                                <em className={cx("flag-icons-sprite flag-vietnam")}></em>
                                <p>Vietnam</p>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {
                emailWidgetShowAsModal && showEmailWidget && tncAcceptance
                ?
                    <Modal isOpen={emailWidgetShowAsModal}
                        overlayClassName="email-login-container-myOverlayClass"
                        style={customStyles}
                    >
                        <EmailLoginOTPWidget
                        user={user}
                        translation={translation}
                        customStyles={customStyles}
                        type={type}
                        handleLoginType={handleLoginType}
                        enabledCountries={enabledCountries}
                        showTabSwitcher={showTabSwitcher}
                        emailWidgetShowAsModal={emailWidgetShowAsModal}
                        onEmailTemplateClose={(flag) => onEmailTemplateClose(flag)}
                        onLoginSuccess={(data) => onLoginSuccess(data)}/>
                    </Modal>
                    :
                    <div className={cx(`email-login-otp-widget ${showEmailWidget && tncAcceptance ? 'show' : 'hide'}`)}>
                        <EmailLoginOTPWidget
                            user={user}
                            translation={translation}
                            type={type}
                            handleLoginType={handleLoginType}
                            enabledCountries={enabledCountries}
                            showTabSwitcher={showTabSwitcher}
                            onEmailTemplateClose={(flag) => onEmailTemplateClose(flag)}
                            onLoginSuccess={(data) => onLoginSuccess(data)}/>
                    </div>
            }
        </div>
    )
}

export default CommunityLoginWidget;


